import { useCallback, useMemo } from 'react';
import { viewCheckbookCategories } from 'src/assets/static/view_checkbook/useCheckbookCategories';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import usePeriodView from 'src/hooks/usePeriodView';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { initialPeriodCheckbookDataState } from '../ViewCheckbookContext';

const ClearFilters = () => {
  const {
    setPeriodCheckbookDataState,
    periodCheckbookDataState,
    confirmBeforeProceeding,
    setEditingGlCodePeriodBudget,
    setGlCodePeriodBudget,
    isEditMode,
  } = useViewCheckbook();

  const { dropdownPeriodFilter, setDropdownPeriodFilter } = usePeriodView();

  const handleClearFilter = useCallback(() => {
    confirmBeforeProceeding(() => {
      setDropdownPeriodFilter(viewCheckbookCategories[2]);
      setPeriodCheckbookDataState({ ...initialPeriodCheckbookDataState });
    });
    if (isEditMode) {
      setEditingGlCodePeriodBudget((prev) => prev?.map((row) => ({ ...row, selected: false })));
    } else {
      setGlCodePeriodBudget((prev) => prev?.map((row) => ({ ...row, selected: false })));
    }
  }, [
    confirmBeforeProceeding,
    isEditMode,
    setDropdownPeriodFilter,
    setEditingGlCodePeriodBudget,
    setGlCodePeriodBudget,
    setPeriodCheckbookDataState,
  ]);

  const isClearFiltersDisabled = useMemo(
    () =>
      dropdownPeriodFilter?.value === 2 ? !periodCheckbookDataState.filter?.filters.length : false,
    [dropdownPeriodFilter?.value, periodCheckbookDataState.filter?.filters.length]
  );

  return <ClearFilterButton onClick={handleClearFilter} disabled={isClearFiltersDisabled} />;
};

export default ClearFilters;
